
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Supabase public credentials - these are safe to be in the code
const SUPABASE_URL = "https://viwmcnyxfurxikjlnjlb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpd21jbnl4ZnVyeGlramxuamxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc2MjkzNzIsImV4cCI6MjA1MzIwNTM3Mn0.--Ehceny23eM3qB6cRbB8DEnU9Rl1yaaCi9uMkOCnMY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
